// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6936559d","884":"80182c0a"}[chunkId] + ".chunk.js";
};